// Centralized config for environment-driven dynamic data
// CRA exposes env vars prefixed with REACT_APP_

const env = (key, fallback = '') => process.env[key] || fallback;

export const COMPANY = {
  NAME: env('REACT_APP_COMPANY_NAME', 'Avarnix Technologies'),
  LOCATION: env('REACT_APP_LOCATION', 'Bhoganhalli Road, Bangalore, India'),
  EMAIL: env('REACT_APP_EMAIL', 'info@avarnix.com'),
  PHONE: env('REACT_APP_PHONE', '+91 84319 29304'),
  WEBSITE_NAME: env('REACT_APP_WEBSITE_NAME', 'www.avarnix.com'),
  WEBSITE_URL: env('REACT_APP_WEBSITE_URL', 'https://www.avarnix.com'),
  BUSINESS_HOURS: env('REACT_APP_BUSINESS_HOURS', 'Mon - Fri: 9AM - 6PM IST')
};

export const SOCIAL = {
  LINKEDIN: env('REACT_APP_SOCIAL_LINKEDIN', '#'),
  TWITTER: env('REACT_APP_SOCIAL_TWITTER', '#'),
  GITHUB: env('REACT_APP_SOCIAL_GITHUB', '#')
};

export const PRODUCTS = {
  FITPULSEBOT_URL: env('REACT_APP_FITPULSEBOT_URL', 'https://www.fitpulsebot.fit/')
};

export const API = {
  BASE_URL: env('REACT_APP_API_BASE_URL', 'https://api.avarnixkids.com')
};

// Feature flags
export const FEATURES = {
  GPT5_ENABLED: env('REACT_APP_FEATURE_GPT5_ENABLED', 'false') === 'true',
  GPT5_ANNOUNCEMENT: env('REACT_APP_FEATURE_GPT5_ANNOUNCEMENT', 'Enable GPT-5 for all clients')
};

const CONFIG = { COMPANY, SOCIAL, PRODUCTS, API, FEATURES };
export default CONFIG;
